import React, { FC } from 'react';

import { BUTTON_TYPES, EvConfirm, TOAST_STATUS } from '@evinced-private/ui-common';

import { SITE_SCANNER_APP_ID } from '../../consts/dom-consts';
import { IPropertyViewRow } from '../../interfaces/PropertyViews';
import { useNotifications } from '../../providers/notificationsProvider/NotificationsConsumer';
import { usePropertyViewContext } from '../../providers/PropertyViewProvider';
import { logger } from '../../services/Logger';
import { deleteView } from '../../services/PropertyViewsService';

import './DeleteViewPopup.scss';

interface IDeleteViewPopup {
	/**
	 * View data
	 */
	view: IPropertyViewRow;
	/**
	 * AccessibilityProps is used to pass accessibility attributes into the trigger button
	 */
	accessibilityProps?: unknown;
}

export const DeleteViewPopup: FC<IDeleteViewPopup> = ({
	view,
	accessibilityProps
}: IDeleteViewPopup) => {
	const propertyViewContext = usePropertyViewContext();
	const notificationsContext = useNotifications();

	const onConfirmDelete = async (closeModal: () => void): Promise<void> => {
		try {
			await deleteView(view.id);
			await propertyViewContext.onViewsChange();
			notificationsContext.toast({
				show: true,
				status: TOAST_STATUS.SUCCESS,
				announcement: 'View deleted'
			});
			closeModal();
		} catch (error) {
			notificationsContext.toast({
				show: true,
				status: TOAST_STATUS.FAIL,
				announcement: 'Failed to delete the view'
			});
			logger.error('Error while deleting the view: ', error);
		}
	};

	return (
		<EvConfirm
			appElement={SITE_SCANNER_APP_ID}
			title="Confirm Delete"
			approveButtonText="Delete"
			onConfirm={onConfirmDelete}
			promptMessage={
				<span>
					Are you sure you want to delete the view <b className="view-name">{view.name}</b>?
				</span>
			}
			triggerButtonProps={{
				type: BUTTON_TYPES.ICON,
				title: 'Delete',
				children: 'Delete',
				accessibilityProps
			}}
			isBgTransparent={true}
		/>
	);
};
